<!--
 * @Date: 2022-06-09 09:40:57
 * @Author: 陶子
 * @LastEditTime: 2022-06-13 10:13:47
 * @FilePath: \jk_one-stop_cloud_mobile_v1.0\src\views\warehouseManagement\warehouse\SearchTag.vue
 * @pageName: 这是--(仓库管理——筛选)--页面
-->
<template>
  <div class="search-content wrap-apply" :style="{top: GLOBAL.currentEnvironment ? '0' : ''}" v-show="showSearchTag">
    <Search ref="topSearch" class="search" placeholder="仓库名称 | 仓库编号" :isAdd="false" :isScreen="false" :isType="false"></Search>
    <div class="searchBox">
      <van-cell-group style="margin-top:0.1rem">
        <p class="label FormTit"><span></span>仓库编号</p>
        <van-field v-model="filterForm.applyNumber" placeholder="请输入" />
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <p class="label FormTit"><span></span>仓库名称</p>
        <van-field v-model="filterForm.warehouseName" placeholder="请输入" />
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <p class="label FormTit"><span></span>审批状态</p>
        <van-field-checkbox :supportClear='true' label="" placeholder="请选择" v-model="flowStatus" :columns="flowStatusList" label-width="100"
          :option="{label:'text',value:'value'}" @confirm='processSelectConfirm("flowStatus",$event)' />
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <p class="label FormTit"><span></span>仓库状态</p>
        <van-field-checkbox :supportClear='true' label="" placeholder="请选择" v-model="status" :columns="stackStateList" label-width="100"
          :option="{label:'text',value:'value'}" @confirm='processSelectConfirm("status",$event)' />
        <div class="bottomLine"></div>
      </van-cell-group>
    </div>
    <div class="search-bottom">
      <span class="btncancel" @click="btnCancel">重置</span>
      <span class="btnconfirm" @click="btnConfirm">确定</span>
    </div>
  </div>
</template>

<script>
const formP = {
  applicantId: "",
  operatorId: "",
  applyTimeBegin: "",
  applyTimeEnd: "",
};
import VanFieldCheckbox from "@/components/ActionSheet/VanFieldCheckbox";
import ContactPickers from "@/components/choiceuse/ContactPickers";
import upload from "@/components/upload/upload";
import VanFieldSelectPicker from "@/components/ActionSheet/VanFieldSelectPicker";
import Search from "@/components/search";
import { processTaskCompletionStatics } from "@/api/mobile";
import { ajaxGetDictItems } from "@/api/api";
import { getDictModel } from "@/api/system.js";
export default {
  name: "search",
  components: {
    ContactPickers,
    upload,
    Search,
    VanFieldSelectPicker,
    VanFieldCheckbox,
  },
  data() {
    return {
      showSearchTag: false,
      /***** */
      filterForm: {},
      flowStatusList: [],
      flowStatus: [],
      status: [],
      stackStateList: [
        {
          text: "已生效",
          value: "effective",
        },
        {
          text: "未生效",
          value: "no_effective",
        },
      ],
    };
  },
  computed: {},
  mounted() {},
  created() {
    this.getDictCode();
  },
  methods: {
    getDictCode() {
      let parameters = { dictCode: "erp_apply_status" };
      getDictModel(parameters).then((res) => {
        if (res.code == 200) {
          console.log(res, "erp_apply_status");
          this.flowStatusList = res.result;
        }
      });
    },

    showModal(keyword, dropdownObj) {
      this.showSearchTag = true;
      this.$nextTick(() => {
        this.$refs.topSearch.value = keyword;
        this.filterForm = JSON.parse(JSON.stringify(dropdownObj));
        this.flowStatus = this.filterForm.flowStatus
          ? this.filterForm.flowStatus.split(",")
          : [];
        this.status = this.filterForm.status
          ? this.filterForm.status.split(",")
          : [];
      });
    },

    processSelectConfirm(arrType, proceArr) {
      if (proceArr) {
        this[arrType] = proceArr;
      } else {
        this[arrType] = [];
      }
    },
    btnCancel() {
      this.$refs.topSearch.value = "";
      this.filterForm = {};
      this.flowStatus = [];
      this.status = [];
    },
    btnConfirm() {
      this.filterForm.flowStatus = this.flowStatus.join(",");
      this.filterForm.status = this.status.join(",");
      let sureObj = {
        ...this.filterForm,
        keyword: this.$refs.topSearch.value,
      };
      this.showSearchTag = false;
      this.$emit("getCategory", sureObj);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/theme.scss";
.search-content {
  //  padding-bottom: 0.5rem;
  position: fixed;
  top: 0.35rem;
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
  z-index: 99;
  .formgroup {
    background: #ffffff;
    // padding: 0 0.16rem;
    margin-top: 0.1rem;
    margin-bottom: 0.2rem;
    padding-top: 0.1rem;

    .title {
      width: 0.58rem;
      height: 0.14rem;
      font-size: 0.15rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #191f25;
      line-height: 0.05rem;
      margin-left: 0.16rem;
    }
  }
  .search-bottom {
    width: 100%;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0px;
    padding: 0.06rem 0.11rem;
    font-size: 0.16rem;
    font-weight: 500;
    .btncancel {
      flex: 1;
      background: #f6f6f6;
      border: 0.01rem solid rgba(25, 31, 37, 0.12);
      box-sizing: border-box;
      height: 0.39rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.03rem;
      margin-right: 0.11rem;
      color: #191f25;
    }
    .btnconfirm {
      flex: 1;
      background: #1890ff;
      box-sizing: border-box;
      height: 0.39rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.03rem;
      color: #ffffff;
    }
  }
}
.bottomLine {
  height: 0.01rem;
  background-color: #f0f0f0;
  margin: 0 0.16rem;
}
.searchBox {
  height: calc(100vh - 1.6rem);
  overflow-y: auto;
}
.haveUnitBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding-right: 0.16rem;
  /deep/ .van-cell {
    padding-right: 0;
    width: 2.6rem;
  }
  /deep/ .van-field__control {
    max-width: 3rem;
  }
}
</style>